import { Button, Modal } from '@neshane/blueberry';

export function UnsavedModal({ isOpen, onClose, onContinue }) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="تغییرات ذخیره نشده"
            iconName="triangle-warning"
            iconVariant="warning"
            actions={[
                <Button
                    key="cancel"
                    variant="secondaryNeutral"
                    text="انصراف"
                    onClick={onClose}
                />,
                <Button
                    key="continue"
                    variant="primaryBrand"
                    text="ادامه بدون ذخیره"
                    onClick={onContinue}
                />,
            ]}
        >
            اطلاعاتی که وارد کردهاید ذخیره نشده است. آیا بدون ذخیره ادامه میدهید؟
        </Modal>
    );
}